export enum paidFeaturesStaticData {
    None = 0,
    Documenter = 1
}